'use client'

import { NON_LEGACY_ROUTES } from 'constants/routesConstants'
import { isPremiumOrPremiumCancelling } from 'features/auth/utils/userStates'
import { useAtom } from 'jotai'
import { notFound } from 'next/navigation'
import { isAnyOfCheckoutRoutes } from 'utils/routes'

import { userAtom } from '@/global-state'
import { usePathname } from '@/i18n-routing'

export const NotFoundRedirector = () => {
	const pathname = usePathname()
	const [user] = useAtom(userAtom)

	if (
		user &&
		isPremiumOrPremiumCancelling(user) &&
		isAnyOfCheckoutRoutes(pathname)
	) {
		notFound()
	}

	if (!(NON_LEGACY_ROUTES as unknown as string[]).includes(pathname)) {
		notFound()
	}

	return null
}
